import { isEmpty } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { Field, useFormContext } from 'app/components/core/Form';
import { Input } from 'app/components/core/Input';

export function UsernameField() {
    const { t } = useTranslation();
    const { getFieldValue, setFieldValue } = useFormContext();

    function handleBlur(value) {
        if (isEmpty(getFieldValue('name'))) {
            setFieldValue('name', value);
        }
    }

    return (
        <Field
            component={Input}
            name="credentials.username"
            label={t('common:username')}
            placeholder={t('forms:common.fields.serviceAccountUser.placeholder')}
            onBlur={handleBlur}
        />
    );
}
